import React, { useMemo } from 'react'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import { useMetrics } from 'redux/hooks/Metrics'
import InvalidMetrics from '../InvalidMetrics'
import { useTranslation } from 'language/translator'

interface NoTargetProps {
  embedded: boolean
  metrics: string[]
  scaleFactor: number
}

const NoTarget = (props: NoTargetProps) => {
  const { embedded, metrics, scaleFactor } = props
  const { t, lang } = useTranslation()

  const [allMetrics] = useMetrics()

  const missingTargets = useMemo(() => {
    if (embedded) {
      return []
    }

    return metrics.map((id) => {
      const exists = allMetrics.find((item) => item.id === id)

      return {
        id,
        title: exists?.title[lang] || t('metrics', 'metric')
      }
    })
  }, [metrics, allMetrics, lang])

  if (embedded) {
    return (
      <EmptyPlaceholder
        background={true}
        title={t('widgets', 'widget_missing_metrics_error')}
        icon="CrisisAlertTwoTone"
        scaleFactor={scaleFactor}
      />
    )
  }

  return (
    <EmptyPlaceholder
      background={true}
      title={
        <>
          {t('widgets', 'widget_missing_metrics_error')}
          <InvalidMetrics metrics={missingTargets} />
        </>
      }
      icon="CrisisAlertTwoTone"
      scaleFactor={scaleFactor}
    />
  )
}

export default NoTarget
